import { render, staticRenderFns } from "./EditTerminals.vue?vue&type=template&id=9ec01a7a"
import script from "./EditTerminals.vue?vue&type=script&lang=js"
export * from "./EditTerminals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports